import { JobOfferPreview } from "@/lib/interfaces/embed";

export const SIMILAR_JOBS_PAGE_SIZE = 3;

export function uniqSimilarJobsById(items: JobOfferPreview[]) {
  const seen = new Set<string>();
  const out: JobOfferPreview[] = [];
  for (const item of items) {
    if (!item?._id) continue;
    if (seen.has(item._id)) continue;
    seen.add(item._id);
    out.push(item);
  }
  return out;
}

/** Stable key when `initialSimilarJobs` is a new array reference but ids are unchanged. */
export function fingerprintSimilarJobIds(initialSimilarJobs: JobOfferPreview[] | undefined): string {
  return (initialSimilarJobs || [])
    .map((j) => j._id)
    .filter(Boolean)
    .sort()
    .join(",");
}
